<!-- 生成外箱码 -->
<template>
    <div class="container">
        <div class="content">
            <Tabs value="1">
                <TabPane label="批量生成外箱码" name="1">
                    <Form
                        :model="formLeft"
                        label-position="right"
                        :label-width="100"
                    >
                        <div class="header">
                            <img
                                class="header-img"
                                src="../../assets/information.png"
                            />
                            <div>
                                对于非预装箱场景，您需要在这里生成外箱码，并将生成的外箱码打印或印刷在外箱上，在执行装箱操作时，跟产品码关联绑定。
                            </div>
                        </div>
                        <FormItem label="生成批次：">
                            <Input
                                class="w300"
                                type="text"
                                v-model="formLeft.batch_name"
                                placeholder="填写生成码箱的批次名称"
                            ></Input>
                            <Tooltip
                                max-width="250"
                                placement="right"
                                theme="light"
                            >
                                <Icon
                                    class="ml24 cursor-p"
                                    type="md-help-circle"
                                    size="20"
                                    color="#FF761D "
                                />
                                <div slot="content">
                                    <p>
                                        用于区分不同时间段生成的箱码，方便管理
                                    </p>
                                </div>
                            </Tooltip>
                        </FormItem>
                        <!-- <FormItem label="溯源码类型：">
                            <Select
                                class="w300"
                                v-model="formLeft.qrcode_type"
                                clearable
                                filterable
                                placeholder="请选择"
                            >
                                <Option
                                    v-for="item in typeList"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.name }}</Option
                                >
                            </Select>
                        </FormItem> -->
                        <FormItem label="生成数量：">
                            <Input
                                class="w300"
                                type="number"
                                v-model="formLeft.qrcode_count"
                                placeholder="本次需要生成的外箱码数量"
                            ></Input>
                            <Tooltip
                                max-width="250"
                                placement="right"
                                theme="light"
                            >
                                <Icon
                                    class="ml24 cursor-p"
                                    type="md-help-circle"
                                    size="20"
                                    color="#FF761D "
                                />
                                <div slot="content">
                                    <p>单次生成数量建议五万以内。</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                        <FormItem label="外箱码长度：">
                            <Input
                                class="w300"
                                type="number"
                                v-model="formLeft.qrcode_length"
                                placeholder="请输入外箱码长度"
                            ></Input>
                            <Tooltip
                                max-width="250"
                                placement="right"
                                theme="light"
                            >
                                <Icon
                                    class="ml24 cursor-p"
                                    type="md-help-circle"
                                    size="20"
                                    color="#FF761D "
                                />
                                <div slot="content">
                                    <p>溯源码的位数,填写12-40之间的数字。</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                        <FormItem label="箱码前缀：">
                            <Input
                                class="w300"
                                type="text"
                                v-model="formLeft.qrcode_prefix"
                                placeholder="如无需要，默认不空即可"
                            ></Input>
                            <Tooltip
                                max-width="250"
                                placement="right"
                                theme="light"
                            >
                                <Icon
                                    class="ml24 cursor-p"
                                    type="md-help-circle"
                                    size="20"
                                    color="#FF761D "
                                />
                                <div slot="content">
                                    <p>
                                        一般不用填写。用于需要为箱码编码开头设置固定英文
                                    </p>
                                </div>
                            </Tooltip>
                        </FormItem>
                        <div class="footer">
                            <Button class="mr24" @click="goGenerateRecords"
                                >生成记录</Button
                            >
                            <Button
                                class="theme-bc theme-default-color"
                                @click="goCreate"
                                >批量生成</Button
                            >
                        </div>
                    </Form>
                </TabPane>
                <TabPane label="批量导出外箱码" name="2">
                    <Form
                        :model="formRight"
                        label-position="right"
                        :label-width="100"
                    >
                        <div class="header">
                            <img
                                class="header-img"
                                src="../../assets/information.png"
                            />
                            <div>
                                对于非预装箱场景，需要将生成的外箱码打印或印刷在外箱上，在执行装箱操作时，跟产品码关联绑定即可。
                            </div>
                        </div>
                        <FormItem label="箱码批次：">
                            <Select
                                class="w300"
                                v-model="formRight.count_id"
                                clearable
                                filterable
                                placeholder="模糊搜索批次"
                            >
                                <Option
                                    v-for="item in countList"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.batch_name }}</Option
                                >
                            </Select>
                            <Tooltip
                                max-width="250"
                                placement="right"
                                theme="light"
                            >
                                <Icon
                                    class="ml24 cursor-p"
                                    type="md-help-circle"
                                    size="20"
                                    color="#FF761D "
                                />
                                <div slot="content">
                                    <p>请选择要导出的箱码的生成批次。</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                        <FormItem label="选择导出项：">
                            <CheckboxGroup v-model="export_value">
                                <Checkbox label="ID号" border></Checkbox>
                                <Checkbox label="外箱码编码" border></Checkbox>
                            </CheckboxGroup>
                        </FormItem>
                        <FormItem label="选择格式：">
                            <Select
                                class="w300"
                                v-model="formRight.export_type"
                                clearable
                                filterable
                                placeholder="请选择格式"
                            >
                                <Option
                                    v-for="item in exportTypeList"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.name }}</Option
                                >
                            </Select>
                            <Tooltip
                                max-width="250"
                                placement="right"
                                theme="light"
                            >
                                <Icon
                                    class="ml24 cursor-p"
                                    type="md-help-circle"
                                    size="20"
                                    color="#FF761D "
                                />
                                <div slot="content">
                                    <p>导出印刷重要说明提示:</p>
                                    <p>
                                        1、推荐导出为CSV文件,可用Excle打开和编辑,并转存为标准的EXCLE和EXCLEX格式。
                                    </p>
                                    <p>
                                        2、导出的数据请打开检查,以确保数据正确和完整。
                                    </p>
                                    <p>
                                        3、正式批量印刷前,请先印几张用于测试,以免错误。
                                    </p>
                                </div>
                            </Tooltip>
                        </FormItem>
                        <FormItem label="文件编码：">
                            <Select
                                class="w300"
                                v-model="formRight.export_set"
                                clearable
                                filterable
                                placeholder="请选择语言"
                            >
                                <Option
                                    v-for="item in exportSetList"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.name }}</Option
                                >
                            </Select>
                            <Tooltip
                                max-width="250"
                                placement="right"
                                theme="light"
                            >
                                <Icon
                                    class="ml24 cursor-p"
                                    type="md-help-circle"
                                    size="20"
                                    color="#FF761D "
                                />
                                <div slot="content">
                                    <p>
                                        包含中文建议选择GBK编码,以防Office打开中文乱码。
                                    </p>
                                </div>
                            </Tooltip>
                        </FormItem>
                        <div class="footer">
                            <Button class="mr24" @click="goExportRecord"
                                >导出记录</Button
                            >
                            <Button
                                class="theme-bc theme-default-color"
                                @click="goExport"
                                >批量导出</Button
                            >
                        </div>
                    </Form>
                </TabPane>
            </Tabs>
        </div>
        <!-- 导出记录 -->
        <Drawer v-model="recordsModal" title="导出记录" width="80">
            <Table :columns="columnsTable" :data="dataTable" border>
                <template slot-scope="{ index }" slot="id">
                    <div>{{ index + 1 }}</div>
                </template>
                <template slot-scope="{ row }" slot="export_type_name">
                    <div>{{ row.export_type_name }}</div>
                </template>
                <template slot-scope="{ row }" slot="status">
                    <div
                        class="success-color"
                        v-if="row.log.every((item) => item.status == 1)"
                    >
                        <Icon
                            type="ios-checkmark-circle-outline"
                            color="#53C41A"
                        />导出成功
                    </div>
                    <div v-else>
                        <div
                            class="flex-c"
                            v-if="row.log.some((item) => item.status == 0)"
                        >
                            <img class="wh18" src="../../assets/loading.gif" />
                            <span class="theme-color">正在导出</span>
                        </div>
                        <div
                            class="fail-color"
                            v-if="row.log.some((item) => item.status == 2)"
                        >
                            <Icon
                                type="ios-close-circle-outline"
                                color="#FF4838"
                            />导出失败
                        </div>
                    </div>
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <Button
                        v-if="row.log.every((item) => item.status == 1)"
                        type="warning"
                        ghost
                        @click="goDownload(row)"
                        >下载</Button
                    >
                </template>
            </Table>
            <div class="table-page">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </Drawer>
        <!-- 生成记录 -->
        <Drawer v-model="createModal" title="生成记录" width="80">
            <Table :columns="columnsCreate" :data="dataCreate" border>
                <template slot-scope="{ index }" slot="id">
                    <div>{{ index + 1 }}</div>
                </template>
                <template slot-scope="{ row }" slot="status">
                    <div
                        class="success-color"
                        v-if="row.qrcode_log.every((item) => item.status == 1)"
                    >
                        <Icon
                            type="ios-checkmark-circle-outline"
                            color="#53C41A"
                        />生成成功
                    </div>
                    <div v-else>
                        <div
                            class="flex-c"
                            v-if="
                                row.qrcode_log.some((item) => item.status == 0)
                            "
                        >
                            <img class="wh18" src="../../assets/loading.gif" />
                            <span style="color: #ff761d">正在生成</span>
                        </div>
                        <div
                            class="fail-color"
                            v-if="
                                row.qrcode_log.some((item) => item.status == 2)
                            "
                        >
                            <Icon
                                type="ios-close-circle-outline"
                                color="#FF4838"
                            />生成失败
                        </div>
                    </div>
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <Button
                        v-if="row.qrcode_log.every((item) => item.status == 1)"
                        type="warning"
                        ghost
                        @click="goPacking(row)"
                        >查看</Button
                    >
                </template>
            </Table>
            <div class="table-page">
                <Page
                    :current="pageCreate.page"
                    :page-size="pageCreate.limit"
                    :total="totalCreate"
                    show-elevator
                    show-total
                    @on-change="pageCreateChange"
                />
            </div>
        </Drawer>
        <!-- 生成记录 查看 -->
        <Drawer v-model="packingDrawer" title="生成记录" width="80">
            <Table :columns="columnsPacking" :data="dataPacking" border>
                <template slot-scope="{ row }" slot="qrcode_url">
                    <div class="flex-c" @click="goPreview(row)">
                        <img class="preview-img" src="@/assets/code_img.png" />
                    </div>
                </template>
            </Table>
            <div class="table-page">
                <Page
                    :current="pagePacking.page"
                    :page-size="pagePacking.limit"
                    :total="totalPacking"
                    show-elevator
                    show-total
                    @on-change="pagePackingChange"
                />
            </div>
        </Drawer>
        <!-- 预览 -->
        <Modal v-model="previewModal" title="预览" width="300">
            <div class="flex-c">
                <VueQr id="vueQr" :text="qrcode_url"></VueQr>
            </div>
            <div slot="footer"></div>
        </Modal>
    </div>
</template>

<script>
import {
    packing_export_list,
    packing_count_create,
    packing_export_qrcode,
    packing_count_list,
    packing_list,
    packing_count_select,
} from "@/api/index";
import VueQr from "vue-qr";
export default {
    components: { VueQr },
    data() {
        return {
            export_value: [],
            formLeft: {
                batch_name: "",
                qrcode_count: "",
                qrcode_length: "",
                qrcode_prefix: "",
                qrcode_type: 1,
            },
            formRight: {
                count_id: "",
                is_id: 0,
                is_number: 0,
                is_qrcode: 0,
                export_set: "",
                export_type: "",
            },
            countList: [],
            exportSetList: [
                { id: 1, name: "国际编码(UTF-8)" },
                { id: 2, name: "简体中文(GBK)" },
            ],
            exportTypeList: [
                { id: 1, name: "EXCLE电子表格" },
                { id: 2, name: "TXT文本文档" },
                { id: 3, name: "CSV格式(支持Excle中打开编辑)" },
            ],
            recordsModal: false,
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            columnsTable: [
                { title: "导出批次", key: "id", align: "center" },
                { title: "导出项", key: "export_action", align: "center" },
                {
                    title: "选择格式",
                    slot: "export_type_name",
                    align: "center",
                },
                {
                    title: "状态",
                    slot: "status",
                    align: "center",
                    width: "200px",
                },
                { title: "导出时间", key: "created_at", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                },
            ],
            dataTable: [],
            createModal: false,
            pageCreate: {
                page: 1,
                limit: 10,
            },
            totalCreate: 0,
            columnsCreate: [
                { title: "生成批次", key: "batch_name", align: "center" },
                { title: "生成数量", key: "qrcode_count", align: "center" },
                { title: "外箱码长度", key: "qrcode_length", align: "center" },
                { title: "箱码前缀", key: "qrcode_prefix", align: "center" },
                {
                    title: "状态",
                    slot: "status",
                    align: "center",
                    width: "200px",
                },
                { title: "生成时间", key: "created_at", align: "center" },
                { title: "操作", slot: "operate", align: "center" },
            ],
            dataCreate: [],
            packingDrawer: false,
            pagePacking: {
                page: 1,
                limit: 10,
                count_id: "",
            },
            totalPacking: 0,
            columnsPacking: [
                { type: "index", width: 60, align: "center" },
                { title: "外箱码", key: "qrcode_number", align: "center" },
                { title: "箱码", slot: "qrcode_url", align: "center" },
                { title: "生成时间", key: "created_at", align: "center" },
            ],
            dataPacking: [],
            previewModal: false,
            qrcode_url: "",
            typeList: [
                { id: 1, name: "前缀+英文字母(大小写混合)+数字" },
                { id: 2, name: "前缀+英文字母(大小写混合)" },
                { id: 3, name: "前缀+纯数字" },
                { id: 4, name: "前缀+英文字母(大写)+数字" },
                { id: 5, name: "前缀+英文字母(大写)" },
            ],
            admin_id: ''
        };
    },
    created() {
        this.admin_id = localStorage.getItem("admin_id");
        // 账号ID：1104
        if (this.admin_id == "1104") {
            this.formLeft.qrcode_type = 3;
        } else {
            this.formLeft.qrcode_type = 1;
        }
    },
    mounted() {
        this.getPackingCountSelect();
    },
    methods: {
        goPreview(row) {
            if (row.qrcode_url) {
                this.qrcode_url = row.qrcode_url;
            } else {
                this.qrcode_url = "";
            }
            this.previewModal = true;
        },
        getList() {
            packing_export_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 外箱码生成记录列表
        getPackingCountList() {
            packing_count_list(this.pageCreate)
                .then((res) => {
                    this.dataCreate = res.data.data;
                    this.totalCreate = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 外箱码列表
        getPackingList() {
            packing_list(this.pagePacking)
                .then((res) => {
                    this.dataPacking = res.data.data;
                    this.totalPacking = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getPackingCountSelect() {
            packing_count_select()
                .then((res) => {
                    this.countList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goCreate() {
            var data = Number(this.formLeft.qrcode_length);
            if (data < 12 || data > 40) {
                this.$Message.error("溯源码的位数，请填写12-40之间的数字。");
                return;
            }
            packing_count_create(this.formLeft)
                .then((res) => {
                    this.$Modal.success({
                        title: "批量生成成功！",
                        content: "恭喜，箱码生成成功！",
                        onOk: () => {
                            this.formLeft.batch_name = "";
                            this.formLeft.qrcode_count = "";
                            this.formLeft.qrcode_length = "";
                            this.formLeft.qrcode_prefix = "";
                        },
                        onCancel: () => {},
                    });
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goExport() {
            this.export_value.forEach((item) => {
                if (item == "ID号") {
                    this.formRight.is_id = 1;
                } else if (item == "外箱码编码") {
                    this.formRight.is_number = 1;
                }
            });
            packing_export_qrcode(this.formRight)
                .then((res) => {
                    this.$Modal.success({
                        title: "批量导出成功！",
                        content:
                            "导出成功，为了数据安全，只做临时存储请 点击“导出记录”下载数据包到本地",
                        onOk: () => {
                            this.formRight.count_id = "";
                            this.formRight.is_id = 0;
                            this.formRight.is_number = 0;
                            this.formRight.is_qrcode = 0;
                            this.formRight.export_set = "";
                            this.formRight.export_type = "";
                        },
                        onCancel: () => {},
                    });
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 生成记录
        goGenerateRecords() {
            this.getPackingCountList();
            setTimeout(() => {
                this.createModal = true;
            }, 300);
        },
        // 导出记录
        goExportRecord() {
            this.getList();
            setTimeout(() => {
                this.recordsModal = true;
            }, 300);
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        pageCreateChange(index) {
            this.pageCreate.page = index;
            this.getPackingCountList();
        },
        pagePackingChange(index) {
            this.pagePacking.page = index;
            this.getPackingList();
        },
        changeDate(e) {
            if (e[0]) {
                this.storePrams.start_time = e[0];
                this.storePrams.end_time = e[1];
            } else {
                this.storePrams.start_time = "";
                this.storePrams.end_time = "";
            }
        },
        // 下载
        goDownload(row) {
            window.open(row.show_path);
        },
        // 查看
        goPacking(row) {
            this.pagePacking.count_id = row.id;
            this.getPackingList();
            setTimeout(() => {
                this.packingDrawer = true;
            }, 300);
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    padding: 24px;
    margin-bottom: 12px;
    color: #ff761d;
    display: flex;
    align-items: center;
}
.header-img {
    width: 24px;
    height: 24px;
    margin-right: 12px;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.table-page {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.footer {
    margin: 12px 0 0 0;
    padding: 24px 0 0 0;
    text-align: center;
    border-top: 1px solid #eee;
}
.wh18 {
    width: 18px;
    height: 18px;
}
.success-color {
    color: #53c41a;
}
.fail-color {
    color: #ff4838;
}
.preview-img {
    width: 30px;
    height: 30px;
    cursor: pointer;
}
.cursor-p {
    cursor: pointer;
}
/* Tabs悬浮样式 */
::v-deep .ivu-tabs-tab:hover {
    color: #ff761d;
}
::v-deep .ivu-checkbox-wrapper-checked.ivu-checkbox-border {
    background: #53c41a;
    border-radius: 5px;
    color: #ffffff;
    border-color: #53c41a;
}
::v-deep .ivu-checkbox {
    display: none;
}
::v-deep .ivu-checkbox.ivu-checkbox-checked {
    display: none;
}
::v-deep .ivu-tabs-tab {
    font-size: 16px;
}
::v-deep .ivu-tabs-nav .ivu-tabs-tab-active {
    color: #ff761d;
    font-size: 16px;
}
::v-deep .ivu-tabs-ink-bar {
    background-color: #ff761d !important;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>